export default __webpack_public_path__ + "static/media/logo-text.69234342.svg";